var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-avatar',{staticClass:"elevation-3",attrs:{"color":_vm.color,"size":_vm.size}},[_c('v-img',{attrs:{"src":_vm.photoPath ? _vm.loadFile(_vm.photoPath) : _vm.defaultPhoto}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }